// extracted by mini-css-extract-plugin
export default {"container":"style_container__GmFSM","label":"style_label__CfLWX","radio":"style_radio__0ZcRl"};